var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",class:['content', ( _obj = {}, _obj[("content--" + _vm.size)] = _vm.size, _obj )]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }